import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Plus, Camera } from "lucide-react";
import BottomNav from "../../components/BottomNav.tsx";
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

const AddModelForm: React.FC = () => {
  const [modelName, setModelName] = useState("");
  const [modelDescription, setModelDescription] = useState("");
  const [modelImage, setModelImage] = useState<string | null>(null);
  const [phases, setPhases] = useState([
    "Body Shop Model Work Instructions",
    "Chassis Line Model Work Instructions",
    "Paint Shop Model Work Instructions",
    "Trim Line Model Work Instructions",
    "QIT Model Work Instructions"
  ]);

  const navigate = useNavigate();

  // Handle Image Upload
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        setModelImage(reader.result as string);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("New Model:", { modelName, modelDescription, modelImage, phases });

    // Redirect back to model listing after submission
    navigate("/admin/add-model");
  };

  return (
    <div className="min-h-screen bg-blue-900 pb-20 flex flex-col items-center">
      {/* Header */}
      <div className="p-4 flex justify-between items-center w-full max-w-5xl">
        <h1 className="text-white text-xl font-bold">{modelName || "Model Name"} | Work Instructions</h1>
        <img src={digitalOceanImageUrl("new%20logos/Asset%204.png")} alt="KMC Logo" className="w-16 h-auto" />
      </div>

      {/* Search Bar */}
      <div className="w-full max-w-4xl px-6 mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Search for an instruction document..."
            className="w-full py-3 px-4 pr-10 rounded-full"
          />
          <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>

      {/* Form Section */}
      
      <form onSubmit={handleSubmit} className=" bg-white h-screen p-6 rounded-3xl shadow-md w-full ">
        <h2 className="text-blue-900 text-xl font-bold mb-4">{modelName || "Model Name"} Instructions</h2>

        {/* Model Description */}
        <div className = "flex flex-col-2 gap-5  lg:gap-80 lg" >
            <div>
                <label className="block mb-4">
                <span className="text-gray-700">Add a short description of the new model:</span>
                <textarea
                    className=" w-full lg:w-100 mt-2 p-3 border rounded-lg"
                    rows={3}
                    value={modelDescription}
                    onChange={(e) => setModelDescription(e.target.value)}
                    required
                />
                </label>
            </div>
            {/* Model Image Upload */}
        <div className="flex flex-col items-center mb-6">
          <label htmlFor="imageUpload" className="cursor-pointer flex flex-col items-center justify-center border border-dashed rounded-lg p-6 w-48 h-48 bg-gray-100 text-gray-500">
            {modelImage ? (
              <img src={modelImage} alt="Model Preview" className="w-full h-full object-cover rounded-lg" />
            ) : (
              <>
                <Camera className="w-10 h-10 mb-2" />
                <span>Add a Model Image</span>
              </>
            )}
          </label>
          <input type="file" id="imageUpload" className="hidden" accept="image/*" onChange={handleImageUpload} />
        </div>

        </div>
        

        {/* Phases / Processes Section */}
        <h3 className="text-blue-900 font-bold mb-4">Phase/Process</h3>
        <div className="space-y-3">
  {phases.map((phase, index) => (
        <div
        key={index}
        className="bg-sky-200 font-semibold rounded-lg p-4 flex justify-between items-center"
        >
        <span className="text-gray-900">{phase}</span>
        <button
            type="button"
            className="text-blue-900"
            onClick={() => navigate(`/admin/add-workstation/${modelName}/${phase.replace(/\s+/g, "-").toLowerCase()}`)}
        >
            <Plus className="w-5 h-5" />
        </button>
        </div>
    ))}
    </div>

        {/* Submit Button */}
        <div className="text-center mb-3 font-bold mt-6 hover:font-bold text-white  ransition-transform transform hover:scale-105">
                  <button
                    className="bg-blue-900 text-white px-6 py-3 rounded-full flex items-center gap-2 mx-auto"
                    onClick={() => navigate("/admin/add-model-form")}
                  >
                    Add Model
                  </button>
        </div>
      </form>

      {/* Bottom Navigation */}
      <BottomNav showBack={true} />
    </div>
  );
};

export default AddModelForm;
